import useCheckRole from "Hooks/APICheckRole";
import React, { useEffect, useState } from "react";
import { Dropdown, Form } from "semantic-ui-react";

const typeOptions = [
  {
    key: "assignment-request",
    value: "assignment-request",
    text: "Assignments",
    label: { color: "blue", empty: true, circular: true },
  },
  {
    key: "allocation-request",
    value: "allocation-request",
    text: "Allocations",
    label: { color: "purple", empty: true, circular: true },
  },
  {
    key: "export-request",
    value: "export-request",
    text: "Exports",
    label: { color: "red", empty: true, circular: true },
  },
  {
    key: "port-request",
    value: "port-request",
    text: "Porting",
    label: { color: "green", empty: true, circular: true },
  },
  {
    key: "global-number-request",
    value: "global-number-request",
    text: "Global Numbers",
    label: { color: "brown", empty: true, circular: true },
  },
  {
    key: "migration-request",
    value: "migration-request",
    text: "Migrations",
    label: { color: "orange", empty: true, circular: true },
  },
];

const TicketTypeSelect = ({ name, value, style, onChange }: any) => {
  const { hasRole, roles } = useCheckRole();

  const [currentValue, setCurrentValue] = useState<any>(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const getTypes = () => {
    const allowedTypes: string[] = [];
    if (hasRole(roles.ticket.types.assignment)) {
      allowedTypes.push("assignment-request");
    }
    if (hasRole(roles.ticket.types.allocation)) {
      allowedTypes.push("allocation-request");
    }
    if (hasRole(roles.ticket.types.porting)) {
      allowedTypes.push("port-request");
    }
    if (hasRole(roles.ticket.types.export)) {
      allowedTypes.push("export-request");
    }
    if (hasRole(roles.ticket.types.globalNumber)) {
      allowedTypes.push("global-number-request");
    }
    if (hasRole(roles.ticket.types.migration)) {
      allowedTypes.push("migration-request");
    }
    return typeOptions.filter((opt) => {
      return allowedTypes.indexOf(opt.key) > -1;
    });
  };

  return (
    <Form.Field>
      <Dropdown
        name={name}
        value={currentValue}
        fluid
        multiple
        search
        selection
        options={getTypes()}
        placeholder='Select Ticket Type'
        style={style}
        onChange={(event, { value }) => {
          setCurrentValue(value);
          onChange(value);
        }}
      />
    </Form.Field>
  );
};

export default TicketTypeSelect;
